import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function FinancialTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, bankAccount, bankDetails, saveBankAccount, setBankDetails, setShowBankModal, showBankModal } = ctx;

  return (
    <>
            {activeTab === 'financial' && (
              <div className="financial-content">
                <h2>Financial Management</h2>
                
                <div className="bank-account-section">
                  <div className="section-header">
                    <h3>Bank Account for Platform Fee Collection</h3>
                    {bankAccount ? (
                      <button className="btn-secondary" onClick={() => setShowBankModal(true)}>
                        Update Bank Account
                      </button>
                    ) : (
                      <button className="btn-primary" onClick={() => setShowBankModal(true)}>
                        Add Bank Account
                      </button>
                    )}
                  </div>

                  {bankAccount ? (
                    <div className="bank-info-card">
                      <div className="bank-detail">
                        <span className="label">Account Holder:</span>
                        <span className="value">{bankAccount.account_holder}</span>
                      </div>
                      <div className="bank-detail">
                        <span className="label">Bank Name:</span>
                        <span className="value">{bankAccount.bank_name}</span>
                      </div>
                      <div className="bank-detail">
                        <span className="label">Account Number:</span>
                        <span className="value">****{bankAccount.account_number?.slice(-4)}</span>
                      </div>
                      <div className="bank-detail">
                        <span className="label">Account Type:</span>
                        <span className="value">{bankAccount.account_type}</span>
                      </div>
                      <div className="bank-detail">
                        <span className="label">Added:</span>
                        <span className="value">{new Date(bankAccount.created_at).toLocaleDateString()}</span>
                      </div>
                    </div>
                  ) : (
                    <p className="no-bank-account">No bank account configured for platform fee collection.</p>
                  )}
                </div>

                {/* Bank Account Modal */}
                {showBankModal && (
                  <div className="modal-overlay" onClick={() => setShowBankModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                      <h3>Bank Account Details</h3>
                      <div className="form-group">
                        <label>Account Holder Name *</label>
                        <input
                          type="text"
                          value={bankDetails.account_holder}
                          onChange={(e) => setBankDetails({...bankDetails, account_holder: e.target.value})}
                          placeholder="John Doe"
                        />
                      </div>
                      <div className="form-group">
                        <label>Bank Name *</label>
                        <input
                          type="text"
                          value={bankDetails.bank_name}
                          onChange={(e) => setBankDetails({...bankDetails, bank_name: e.target.value})}
                          placeholder="Bank of America"
                        />
                      </div>
                      <div className="form-group">
                        <label>Account Number *</label>
                        <input
                          type="text"
                          value={bankDetails.account_number}
                          onChange={(e) => setBankDetails({...bankDetails, account_number: e.target.value})}
                          placeholder="1234567890"
                        />
                      </div>
                      <div className="form-group">
                        <label>Routing Number *</label>
                        <input
                          type="text"
                          value={bankDetails.routing_number}
                          onChange={(e) => setBankDetails({...bankDetails, routing_number: e.target.value})}
                          placeholder="123456789"
                        />
                      </div>
                      <div className="form-group">
                        <label>Account Type *</label>
                        <select
                          value={bankDetails.account_type}
                          onChange={(e) => setBankDetails({...bankDetails, account_type: e.target.value})}
                        >
                          <option value="checking">Checking</option>
                          <option value="savings">Savings</option>
                        </select>
                      </div>
                      <div className="modal-actions">
                        <button className="btn-secondary" onClick={() => setShowBankModal(false)}>
                          Cancel
                        </button>
                        <button className="btn-primary" onClick={saveBankAccount}>
                          Save Bank Account
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
    </>
  );
}
